// TODO: This is a clunky way of doing conditional import.
// Remove once Sentry introduces a universal import, or
// otherwise refactor, maybe using null-loader?
const Sentry = process.env.BROWSER ? require('@sentry/browser') : require('@sentry/node');

/**
 * @param {Response} response
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const fetchCatch = response => {
  // TODO: make this return useful information.
};

export const { configureScope } = Sentry;
